import { ReactElement, StrictMode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Unhead, UnheadProvider } from '@unhead/react/client';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable auto retries in local dev as it's very likely the failure
      // is caused by a code change, not network issues.
      retry: import.meta.env.MODE === 'development' ? false : 3,
    },
  },
});

const createAppRoot = (app: ReactElement, unhead: Unhead) => {
  return (
    <StrictMode>
      <UnheadProvider head={unhead}>
        <QueryClientProvider client={queryClient}>{app}</QueryClientProvider>
      </UnheadProvider>
    </StrictMode>
  );
};

export default createAppRoot;
